<ng-container *ngFor="let c of _service.state?.categories">
    <button
        class="cmps-event-centre-tab-bar--button cmps-cdk-px-0"
        *ngIf="c.categoryId === _service.state?.categoryId"
    >
        <div class="cmps-event-centre-tab-bar--active">
            <cmps-icon
                class="cmps-cdk-mr-0dot5"
                [style.color]="c.colour"
                [svgIcon]="c.icon"
            ></cmps-icon>
            <span [style.color]="c.colour">{{ c.label | translate }}</span>
            <cmps-badge
                [class.cmps-cdk-ml-0dot5]="c.unreadCount > 0"
                [cmpsBadge]="c.unreadCountLabel"
                [cmpsBadgeHidden]="c.unreadCount <= 0"
                cmpsBadgeClassName="cmps-cdk-bg-color-red-100"
            ></cmps-badge>
        </div>
        <div
            class="cmps-event-centre-tab-bar--active-underline"
            [style.background-color]="c.colour"
        ></div>
    </button>
    <button
        class="cmps-event-centre-tab-bar--button"
        [cmpsTooltipTrigger]="c.label | translate"
        placement="top-center"
        (click)="_onCategoryClick(c.categoryId)"
        *ngIf="c.categoryId !== _service.state?.categoryId"
    >
        <div
            [cmpsBadge]="c.unreadCountLabel"
            cmpsBadgePlacement="bottom-right"
            [cmpsBadgeHidden]="c.unreadCount <= 0"
            cmpsBadgeClassName="cmps-cdk-bg-color-red-100"
        >
            <cmps-icon
                [style.color]="c.colour"
                [svgIcon]="c.icon"
            ></cmps-icon>
        </div>
    </button>
</ng-container>
